module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper home"
  }, [_c('section', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "showreel__fallback-image",
    style: ('background-image:url(' + _vm.document.fallbackImage + ')')
  }), _vm._v(" "), (_vm.showVideo) ? _c('video', {
    class: _vm.isEdge ? 'showreel__video is-not-object-fit' : 'showreel__video is-object-fit',
    attrs: {
      "playsinline": true,
      "autoplay": true,
      "loop": true
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.document.native_video_webm.url,
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.document.native_video_mp4.url,
      "type": "video/mp4"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro__content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.document.subtitle))])])])]), _vm._v(" "), _c('section', {
    staticClass: "subjects"
  }, [_c('div', {
    staticClass: "subjects__intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', [_vm._v(_vm._s(_vm.document.intro))])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('c-services-list', {
    attrs: {
      "modifier": "inverted"
    }
  })], 1)]), _vm._v(" "), _c('c-clients', {
    attrs: {
      "filter": "featured"
    }
  }), _vm._v(" "), _c('c-project-list', {
    attrs: {
      "featured": true
    }
  }), _vm._v(" "), _c('div', {
    class: this.settings.currentLang === 'de-ch' ? 'container' : 'container container--spaced'
  }, [_c('router-link', {
    staticClass: "btn-projects",
    attrs: {
      "to": _vm.settings.currentLang === 'de-ch' ? '/work/' : '/en/work/'
    }
  }, [_vm._v(_vm._s(_vm.localizedAllWorkButtonText))])], 1), _vm._v(" "), (_vm.blogLoaded && _vm.settings.currentLang === 'de-ch') ? _c('c-blog-posts-list', {
    attrs: {
      "posts": _vm.featuredPosts,
      "button": "allPosts",
      "compact": "true"
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c7df32a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 270
// module chunks = 0